import { http, type HttpResponse } from 'interfaces'

/**
 * Response shape returned by every bulk-assign cascade endpoint
 * (TI-3915 Member offices, TI-3916 Leadership/Officer offices, and the
 * sibling Committee Story to follow). Co-located with the first service
 * to use it; sibling services re-import from here.
 */
export interface BulkAssignResult {
  affected: number
  stafferIds: number[]
}

export async function bulkAssignMemberOffice (
  memberId: number,
  officeLocationId: number
): Promise<HttpResponse<BulkAssignResult>> {
  const response = await http.post<HttpResponse<BulkAssignResult>>(
    `/api/v1/us/member/${memberId}/offices/${officeLocationId}/bulk-assign/`
  )
  return response.data
}
